export const isCompatibleSource = (a, b) => {
    if (a === b)
        return true;
    if (!a || !b)
        return false;
    if (a.url && b.url)
        return a.url === b.url;
    if (!a.ssai || !b.ssai || a.ssai.type !== b.ssai.type)
        return false;
    if (a.ssai.type === 'awsmediatailor' && b.ssai.type === 'awsmediatailor')
        return a.ssai.sessionUrl === b.ssai.sessionUrl;
    if (a.ssai.type === 'googledai' && b.ssai.type === 'googledai')
        return (a.ssai.assetKey === b.ssai.assetKey && a.ssai.contentSourceId === b.ssai.contentSourceId);
    return false;
};
//# sourceMappingURL=source.js.map